import React from "react";
import { useLanguage } from "../context/LanguageContext";

const Specialties = () => {
  const { t } = useLanguage();

  return (
    <section
      id="specialties"
      data-testid="specialties-section"
      className="section-padding bg-[#F8FAFC] relative"
    >
      {/* Decorative orange stripe */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#FF5A1F]/30 to-transparent" />

      <div className="container-page">
        <div className="max-w-3xl">
          <span className="chip mb-5">{t.specialties.eyebrow}</span>
          <h2
            data-testid="specialties-title"
            className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]"
          >
            {t.specialties.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
            {t.specialties.lead}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.specialties.cards.map((card, i) => (
            <article
              key={card.slug}
              data-testid={`specialty-card-${card.slug}`}
              className="group relative overflow-hidden rounded-2xl bg-white border border-border p-7 card-hover"
            >
              <div className="flex items-start justify-between">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-[#0A192F] text-white text-xl">
                  <i className={`fa-solid ${card.icon}`} aria-hidden="true"></i>
                </div>
                <span className="font-display text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground">
                  0{i + 1}
                </span>
              </div>

              <h3 className="mt-6 font-display text-2xl font-bold text-navy">
                {card.title}
              </h3>
              <p className="mt-2 text-sm text-foreground/70 leading-relaxed min-h-[56px]">
                {card.short}
              </p>

              <ul className="mt-5 space-y-2">
                {card.bullets.map((b, j) => (
                  <li
                    key={j}
                    className="flex items-start gap-2.5 text-[13px] text-foreground/80"
                  >
                    <i className="fa-solid fa-angle-right text-[#FF5A1F] mt-1 text-[11px]" aria-hidden="true"></i>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>

              {/* Decorative hover bar */}
              <div className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-[#FF5A1F] transition-transform duration-500 group-hover:scale-x-100" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specialties;
